// extracted by mini-css-extract-plugin
export default {"section":"b2q2oU","headline":"c2q2oU","list":"d2q2oU","item":"e2q2oU"};